import { render, staticRenderFns } from "./UserBlackIcon.vue?vue&type=template&id=1d79c00e"
import script from "./UserBlackIcon.vue?vue&type=script&lang=js"
export * from "./UserBlackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports